import React, { useEffect, useRef, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import qryto_offcial from "../assets/images/logo/qrypto-official-logo.png"
import { PrimaryButton } from './StyledButtons'
import cheveron_down from "../assets/images/icons/cheveron_down_12px_white.svg"
import { ClickAwayListener, Divider, Grow, Link, MenuItem, MenuList, Paper, Popper, useMediaQuery } from '@mui/material'
import { CenterMenuItem, CustomNavbarMenuList, StyledLinkWhite } from './StyledComponents'
import { useTranslation } from 'react-i18next'
import theme from '../assets/themes/theme'
import { Close, Menu, SearchOutlined } from '@mui/icons-material'
import SearchInfoModal from './SearchInfoModal'
import ModalContactGetTrialForm from './ModalContactGetTrialForm'


const Navbar = () => {
    const { t } = useTranslation();

    const [openUseCase, setOpenUseCase] = useState(false);
    const [openTechno, setOpenTechno] = useState(false);
    const [openResources, setOpenResources] = useState(false);
    const [openCompany, setOpenCompany] = useState(false);

    const anchorRefUseCase = useRef(null);
    const anchorRefTechno = useRef(null);
    const anchorRefResources = useRef(null);
    const anchorRefCompany = useRef(null);


    const handleToggleUseCase = () => {
        setOpenUseCase((prevOpenUseCase) => !prevOpenUseCase);
        setOpenTechno(false);
        setOpenCompany(false);
        setOpenResources(false);
    };

    const handleToggleTechno = () => {
        setOpenTechno((prevOpenTechno) => !prevOpenTechno);
        setOpenUseCase(false);
        setOpenCompany(false);
        setOpenResources(false);
    };

    const handleToggleResource = () => {
        setOpenResources((prevOpenResources) => !prevOpenResources);
        setOpenTechno(false);
        setOpenCompany(false);
        setOpenUseCase(false);
    };

    const handleToggleCompany = () => {
        setOpenCompany((prevOpenCompany) => !prevOpenCompany);
        setOpenUseCase(false);
        setOpenTechno(false);
        setOpenResources(false);
    };

    const handleClose = (event) => {
        if (anchorRefUseCase.current && anchorRefUseCase.current.contains(event.target)) {
            return;
        }
        if (anchorRefTechno.current && anchorRefTechno.current.contains(event.target)) {
            return;
        }
        if (anchorRefResources.current && anchorRefResources.current.contains(event.target)) {
            return;
        }
        if (anchorRefCompany.current && anchorRefCompany.current.contains(event.target)) {
            return;
        }

        setOpenUseCase(false);
        setOpenTechno(false);
        setOpenResources(false);
        setOpenCompany(false);
    };



    const closeMenuOpen = () => {
        setOpenUseCase(false);
        setOpenTechno(false);
        setOpenResources(false);
        setOpenCompany(false);
    };





    useEffect(() => {
        window.addEventListener('resize', closeMenuOpen);
        return () => {
            window.removeEventListener('resize', closeMenuOpen);
        };
    }, []);



    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenUseCase(false);
            setOpenTechno(false);
            setOpenResources(false);
            setOpenCompany(false);
        } else if (event.key === 'Escape') {
            setOpenUseCase(false);
            setOpenTechno(false);
            setOpenResources(false);
            setOpenCompany(false);
        }
    }


    const prevOpenUseCase = useRef(openUseCase);
    const prevOpenTechno = useRef(openTechno);
    const prevOpenResources = useRef(openResources);
    const prevOpenCompany = useRef(openCompany);

    useEffect(() => {
        if (prevOpenUseCase.current === true && openUseCase === false) {
            anchorRefUseCase.current.focus();
        }
        else {
            return;
        }
        prevOpenUseCase.current = openUseCase;
    }, [openUseCase]);

    useEffect(() => {
        if (prevOpenTechno.current === true && openTechno === false) {
            anchorRefTechno.current.focus();
        }
        else {
            return;
        }
        prevOpenTechno.current = openTechno;
    }, [openTechno]);

    useEffect(() => {
        if (prevOpenResources.current === true && openResources === false) {
            anchorRefResources.current.focus();
        }
        else {
            return;
        }
        prevOpenResources.current = openResources;
    }, [openResources]);

    useEffect(() => {
        if (prevOpenCompany.current === true && openCompany === false) {
            anchorRefCompany.current.focus();
        }
        else {
            return;
        }
        prevOpenCompany.current = openCompany;
    }, [openCompany]);

    const isMatch = useMediaQuery(theme.breakpoints.down("navbar"));

    const [openHamburgerMenu, setOpenHamburgurMenu] = useState(false);

    const handleOpenHamburgerMenu = () => {
        setOpenHamburgurMenu(!openHamburgerMenu);

    }

    const a = document.getElementById("root").offsetWidth;

    useEffect(() => {

        if (document.getElementById("root").offsetWidth > 974) {


        } else {
            closeMenuOpen();
        }

    }, [a])

    const [modalSearchOpen, setModalSearchOpen] = useState(false)

    const [modalGetTrialOpen, setModalGetTrialOpen] = useState(false);

    // useEffect(() => {
    //     if (modalSearchOpen === true) {
    //         document.body.style.overflow = "hidden";

    //     } else {
    //         document.body.style.overflow = "auto";
    //     }
    // }, [modalSearchOpen])

    const modalSearchRef = useRef(null);

    const modalGetTrialRef = useRef(null);

    const handleOverlayClick = (event) => {
        if (modalSearchRef.current && !modalSearchRef.current.contains(event.target)) {
            setModalSearchOpen(false)
        }
        if (modalGetTrialRef.current && !modalGetTrialRef.current.contains(event.target)) {
            setModalGetTrialOpen(false)
        }
    };

    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalSearchOpen(false)
            setModalGetTrialOpen(false)
        }
    };


    return (
        <>
            <nav className='navbar pt-20'>
                <div className='container'>
                    {!isMatch ?
                        <div className='navbar-header'>
                            <div className='header-logo'>
                                <Link component={RouterLink} to="/"><img src={qryto_offcial} alt="qryto-offcial" className='img-responsive' /></Link>
                            </div>

                            <div className='header-list'>
                                <ul className='header-list-left'>
                                    <li className="header-list-left_item" id="open-use-case" >
                                        <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefUseCase}
                                            id="use-case-button"
                                            aria-controls={openUseCase ? 'use-case-menu' : undefined}
                                            aria-expanded={openUseCase ? 'true' : undefined}
                                            aria-haspopup="true"
                                            className='link-navbar-outside'
                                            onClick={handleToggleUseCase}>
                                            {t('navbar.use-cases')}
                                            <img src={cheveron_down} alt="cheveron_down" className={openUseCase ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                        </Link>
                                        <div>
                                            <Popper
                                                open={openUseCase}
                                                anchorEl={anchorRefUseCase.current}
                                                role={undefined}
                                                placement="bottom-start"
                                                transition
                                                disablePortal
                                            >
                                                {({ TransitionProps, placement }) => (
                                                    <Grow
                                                        {...TransitionProps}
                                                        style={{
                                                            transformOrigin:
                                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                        }}
                                                    >
                                                        <Paper>
                                                            <ClickAwayListener onClickAway={handleClose}>
                                                                <CustomNavbarMenuList
                                                                    autoFocusItem={openUseCase}
                                                                    id="use-case-menu"
                                                                    aria-labelledby="use-case-button"
                                                                    onKeyDown={handleListKeyDown}
                                                                    className='navbar-dropdown-list'
                                                                >
                                                                    <MenuItem disabled style={{ paddingLeft: 0 }}>
                                                                        <p className='text-white font-10'>{t('navbar.industry')}</p>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/industries">{t('navbar.all-industries')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/industries/general-and-hr">{t('navbar.general')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/industries/banking-and-financial">{t('navbar.banking-financial')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/industries/insurance">{t('navbar.insurance')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/industries/government">{t('navbar.government-regulators')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/industries/healthcare">{t('navbar.healthcare')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/industries/education">{t('navbar.education')}</Link>
                                                                    </MenuItem>
                                                                </CustomNavbarMenuList>
                                                            </ClickAwayListener>
                                                        </Paper>
                                                    </Grow>
                                                )}
                                            </Popper>
                                        </div>

                                    </li>
                                    <li className='header-list-left_item'>
                                        <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefTechno}
                                            id="techno-button"
                                            aria-controls={openTechno ? 'techno-menu' : undefined}
                                            aria-expanded={openTechno ? 'true' : undefined}
                                            aria-haspopup="true"
                                            className='link-navbar-outside'
                                            onClick={handleToggleTechno}>
                                            {t('navbar.technology')}
                                            <img src={cheveron_down} alt="cheveron_down" className={openTechno ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                        </Link>
                                        <div>
                                            <Popper
                                                open={openTechno}
                                                anchorEl={anchorRefTechno.current}
                                                role={undefined}
                                                placement="bottom-start"
                                                transition
                                                disablePortal
                                            >
                                                {({ TransitionProps, placement }) => (
                                                    <Grow
                                                        {...TransitionProps}
                                                        style={{
                                                            transformOrigin:
                                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                        }}
                                                    >
                                                        <Paper>
                                                            <ClickAwayListener onClickAway={handleClose}>
                                                                <CustomNavbarMenuList
                                                                    autoFocusItem={openTechno}
                                                                    id="techno-menu"
                                                                    aria-labelledby="techno-button"
                                                                    onKeyDown={handleListKeyDown}
                                                                    className='navbar-dropdown-list'
                                                                >
                                                                    <MenuItem disabled style={{ paddingLeft: 0 }}>
                                                                        <p className='text-white font-10'>{t('navbar.technology').toUpperCase()}</p>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/technology">{t('navbar.all-technologies')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/technology/overview">{t('navbar.overview')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/technology/deployment">{t('navbar.deployment-options')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/technology/integration">{t('navbar.integration-options')}</Link></MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/technology/generating_pdf_reports_and_documents">{t('navbar.pdf-generation')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/technology/security">{t('navbar.security-privacy')}</Link>
                                                                    </MenuItem>
                                                                </CustomNavbarMenuList>
                                                            </ClickAwayListener>
                                                        </Paper>
                                                    </Grow>
                                                )}
                                            </Popper>
                                        </div>
                                    </li>
                                    <li className='header-list-left_item'>
                                        <Link className='link-navbar-outside' style={{ textDecoration: "none", color: "white" }} component={RouterLink} to="/pricing">{t('navbar.pricing')}</Link>
                                    </li>
                                    <li className='header-list-left_item'>
                                        <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefResources}
                                            id="resources-button"
                                            aria-controls={openResources ? 'resources-menu' : undefined}
                                            aria-expanded={openResources ? 'true' : undefined}
                                            aria-haspopup="true"
                                            className='link-navbar-outside'
                                            onClick={handleToggleResource}>
                                            {t('navbar.resources')}
                                            <img src={cheveron_down} alt="cheveron_down" className={openResources ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                        </Link>
                                        <div>
                                            <Popper
                                                open={openResources}
                                                anchorEl={anchorRefResources.current}
                                                role={undefined}
                                                placement="bottom-start"
                                                transition
                                                disablePortal
                                            >
                                                {({ TransitionProps, placement }) => (
                                                    <Grow
                                                        {...TransitionProps}
                                                        style={{
                                                            transformOrigin:
                                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                        }}
                                                    >
                                                        <Paper>
                                                            <ClickAwayListener onClickAway={handleClose}>
                                                                <CustomNavbarMenuList
                                                                    autoFocusItem={openResources}
                                                                    id="resources-menu"
                                                                    aria-labelledby="resources-button"
                                                                    onKeyDown={handleListKeyDown}
                                                                    className='navbar-dropdown-list menu-columns resources'
                                                                >
                                                                    <div className='menu-resources-item'>
                                                                        <MenuItem disabled style={{ paddingLeft: 0 }}>
                                                                            <p className='text-white font-10'>{t('navbar.case-studies')}</p>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/case-study">{t('navbar.all-case-studies')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/case-study/ashoka">{t('navbar.ashoka-university')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose} style={{ whiteSpace: 'normal', width: "200px" }}>
                                                                            <Link component={RouterLink} to="/case-study/karibia">{t('navbar.karibia-technology-solutions-limited')}</Link>
                                                                        </MenuItem>
                                                                    </div>

                                                                    <div className='menu-resources-item'>
                                                                        <MenuItem disabled style={{ paddingLeft: 0 }}>
                                                                            <p className='text-white font-10'>{t('navbar.whitepapers').toUpperCase()}</p>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/whitepapers">{t('navbar.all-whitepapers')}</Link></MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/whitepapers/banking">{t('navbar.banking')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}
                                                                            style={{ whiteSpace: 'normal', width: "220px" }}
                                                                        >
                                                                            <Link component={RouterLink} to="/whitepapers/eu-dcc">{t('navbar.eu-dcc')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/whitepapers/hr-document-security">{t('navbar.hr-document-security')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/whitepapers/pdf-stamping">{t('navbar.pdf-stamping')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/whitepapers/document-security">{t('navbar.document-security')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/whitepapers/testing-inspection">{t('navbar.testing-inspection')}</Link>
                                                                        </MenuItem>
                                                                    </div>


                                                                    <div className='menu-resources-item'>
                                                                        <MenuItem disabled style={{ paddingLeft: 0 }}>
                                                                            <p className='text-white font-10'>{t('navbar.others')}</p>
                                                                        </MenuItem>
                                                                        <MenuItem onClick={handleClose}>
                                                                            <Link component={RouterLink} to="/faq">{t('navbar.faq')}</Link>
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            onClick={
                                                                                () => localStorage.removeItem('currentPage')
                                                                            }>
                                                                            <Link component={RouterLink} to="/blog" >{t('navbar.blog')}</Link>
                                                                        </MenuItem>
                                                                    </div>
                                                                </CustomNavbarMenuList>
                                                            </ClickAwayListener>
                                                        </Paper>
                                                    </Grow>
                                                )}
                                            </Popper>
                                        </div>
                                    </li>
                                    <li className='header-list-left_item'>
                                        <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefCompany}
                                            id="company-button"
                                            aria-controls={openCompany ? 'company-menu' : undefined}
                                            aria-expanded={openCompany ? 'true' : undefined}
                                            aria-haspopup="true"
                                            className='link-navbar-outside'
                                            onClick={handleToggleCompany}>
                                            {t('navbar.company')}
                                            <img src={cheveron_down} alt="cheveron_down" className={openCompany ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                        </Link>
                                        <div>
                                            <Popper
                                                open={openCompany}
                                                anchorEl={anchorRefCompany.current}
                                                role={undefined}
                                                placement="bottom-start"
                                                transition
                                                disablePortal
                                            >
                                                {({ TransitionProps, placement }) => (
                                                    <Grow
                                                        {...TransitionProps}
                                                        style={{
                                                            transformOrigin:
                                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                        }}
                                                    >
                                                        <Paper>
                                                            <ClickAwayListener onClickAway={handleClose}>
                                                                <CustomNavbarMenuList
                                                                    autoFocusItem={openCompany}
                                                                    id="company-menu"
                                                                    aria-labelledby="company-button"
                                                                    onKeyDown={handleListKeyDown}
                                                                    className='navbar-dropdown-list'
                                                                >

                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/about-us">{t('navbar.about-us')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/contact">{t('navbar.contact-us')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/terms-of-service">{t('navbar.terms-conditions')}</Link>
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleClose}>
                                                                        <Link component={RouterLink} to="/privacy-policy">{t('navbar.privacy-policy')}</Link>
                                                                    </MenuItem>

                                                                </CustomNavbarMenuList>
                                                            </ClickAwayListener>
                                                        </Paper>
                                                    </Grow>
                                                )}
                                            </Popper>
                                        </div>
                                    </li>
                                </ul>
                                <ul className='header-list-right'>
                                    <li className='header-list-right_item navbar-icon' onClick={() => setModalSearchOpen(true)}>
                                        <SearchOutlined />
                                    </li>
                                    <li className='header-list-right_item navbar-button'>
                                        <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>{t('button.get-a-free-trial')}</PrimaryButton>
                                    </li>
                                </ul>
                            </div>



                        </div>
                        :
                        //Hamburger Menu
                        <div>
                            <div className='navbar-header'>
                                <div className='header-logo'>
                                    <Link component={RouterLink} to="/"><img src={qryto_offcial} alt="qryto-offcial" className='img-responsive' /></Link>
                                </div>

                                <div className='hamburger-menu' onClick={handleOpenHamburgerMenu}>
                                    {!openHamburgerMenu ?
                                        <Menu className='hamburger-menu-icon' />
                                        : <Close className='hamburger-menu-icon' />
                                    }
                                </div>
                            </div>
                            {openHamburgerMenu
                                ? <div className='col-sm-12 px-0 pt-10'>
                                    <div className='hamburger-menu-content'>
                                        <ul className='list-unstyled text-center'>
                                            <li className="hamburger-menu-content_item">
                                                <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefUseCase}
                                                    id="use-case-button"
                                                    aria-controls={openUseCase ? 'use-case-menu' : undefined}
                                                    aria-expanded={openUseCase ? 'true' : undefined}
                                                    aria-haspopup="true"
                                                    onClick={handleToggleUseCase}>
                                                    {t('navbar.use-cases')}
                                                    <img src={cheveron_down} alt="cheveron_down" className={openUseCase ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                                </Link>

                                                {openUseCase ?
                                                    <MenuList
                                                        autoFocusItem={openUseCase}
                                                        id="use-case-menu"
                                                        aria-labelledby="use-case-button"
                                                        onKeyDown={handleListKeyDown}

                                                    >
                                                        <CenterMenuItem disabled>
                                                            <p className='text-white font-10'>{t('navbar.industry')}</p>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/industries">{t('navbar.all-industries')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/industries/general-and-hr">{t('navbar.general')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/industries/banking-and-financial">{t('navbar.banking-financial')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/industries/insurance">{t('navbar.insurance')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/industries/government">{t('navbar.government-regulators')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/industries/healthcare">{t('navbar.healthcare')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/industries/education">{t('navbar.education')}</Link>
                                                        </CenterMenuItem>
                                                    </MenuList>
                                                    : null}
                                            </li>
                                            <li className="hamburger-menu-content_item">
                                                <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefTechno}
                                                    id="techno-button"
                                                    aria-controls={openTechno ? 'techno-menu' : undefined}
                                                    aria-expanded={openTechno ? 'true' : undefined}
                                                    aria-haspopup="true"
                                                    onClick={handleToggleTechno}>
                                                    {t('navbar.technology')}
                                                    <img src={cheveron_down} alt="cheveron_down" className={openTechno ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                                </Link>

                                                {openTechno ?
                                                    <MenuList
                                                        autoFocusItem={openTechno}
                                                        id="techno-menu"
                                                        aria-labelledby="techno-button"
                                                        onKeyDown={handleListKeyDown}
                                                    >
                                                        <CenterMenuItem disabled>
                                                            <p className='text-white font-10'>{t('navbar.technology').toUpperCase()}</p>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/technology">{t('navbar.all-technologies')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/technology/overview">{t('navbar.overview')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/technology/deployment">{t('navbar.deployment-options')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/technology/integration">{t('navbar.integration-options')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/technology/generating_pdf_reports_and_documents">{t('navbar.pdf-generation')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/technology/security">{t('navbar.security-privacy')}</Link>
                                                        </CenterMenuItem>
                                                    </MenuList>
                                                    : null}
                                            </li>
                                            <li className='hamburger-menu-content_item'>
                                                <StyledLinkWhite component={RouterLink} to="/pricing">
                                                    <p className='hamburger-menu-content_item__pricing'>{t('navbar.pricing')}</p>
                                                </StyledLinkWhite>
                                            </li>
                                            {/* <li className='hamburger-menu-content_item flex justify-center gap-20'>
                                            <StyledLinkWhite><p className='hamburger-menu-content_item__pricing'>EN</p></StyledLinkWhite>
                                            <StyledLinkWhite><p className='hamburger-menu-content_item__pricing'>VI</p></StyledLinkWhite>
                                        </li> */}
                                            <li className="hamburger-menu-content_item">
                                                <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefResources}
                                                    id="resources-button"
                                                    aria-controls={openResources ? 'resources-menu' : undefined}
                                                    aria-expanded={openResources ? 'true' : undefined}
                                                    aria-haspopup="true"
                                                    onClick={handleToggleResource}
                                                >
                                                    {t('navbar.resources')}
                                                    <img src={cheveron_down} alt="cheveron_down" className={openResources ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                                </Link>

                                                {openResources ?
                                                    <MenuList
                                                        autoFocusItem={openResources}
                                                        id="resources-menu"
                                                        aria-labelledby="resources-button"
                                                        onKeyDown={handleListKeyDown}

                                                    >
                                                        <CenterMenuItem disabled>
                                                            <p className='text-white font-10'>{t('navbar.case-studies')}</p>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link href='/case-study'>{t('navbar.all-case-studies')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link href='/case-study/ashoka'>{t('navbar.ashoka-university')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link href='/case-study/karibia'>{t('navbar.karibia-technology-solutions-limited')}</Link>
                                                        </CenterMenuItem>
                                                        <Divider style={{ backgroundColor: "white" }} />
                                                        <CenterMenuItem disabled>
                                                            <p className='text-white font-10'>{t('navbar.whitepapers').toUpperCase()}</p>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/whitepapers">{t('navbar.all-whitepapers')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/whitepapers/banking">{t('navbar.banking')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/whitepapers/eu-dcc">{t('navbar.eu-dcc')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/whitepapers/hr-document-security">{t('navbar.hr-document-security')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/whitepapers/pdf-stamping">{t('navbar.pdf-stamping')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/whitepapers/document-security">{t('navbar.document-security')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/whitepapers/testing-inspection">{t('navbar.testing-inspection')}</Link>
                                                        </CenterMenuItem>

                                                        <Divider style={{ backgroundColor: "white" }} />
                                                        <CenterMenuItem disabled>
                                                            <p className='text-white font-10'>{t('navbar.others')}</p>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/faq">{t('navbar.faq')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem
                                                            onClick={
                                                                () => localStorage.removeItem('currentPage')
                                                            }>
                                                            <Link component={RouterLink} to="/blog">{t('navbar.blog')}</Link>
                                                        </CenterMenuItem>
                                                    </MenuList>
                                                    : null}
                                            </li>
                                            <li className="hamburger-menu-content_item">
                                                <Link component="button" style={{ textDecoration: "none", color: "white" }} ref={anchorRefCompany}
                                                    id="company-button"
                                                    aria-controls={openCompany ? 'company-menu' : undefined}
                                                    aria-expanded={openCompany ? 'true' : undefined}
                                                    aria-haspopup="true"
                                                    onClick={handleToggleCompany}>
                                                    {t('navbar.company')}
                                                    <img src={cheveron_down} alt="cheveron_down" className={openCompany ? "pl-3 reverse-icon" : 'pl-3 unreverse-icon'} />
                                                </Link>

                                                {openCompany ?
                                                    <MenuList
                                                        autoFocusItem={openCompany}
                                                        id="company-menu"
                                                        aria-labelledby="company-button"
                                                        onKeyDown={handleListKeyDown}
                                                    >
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/about-us">{t('navbar.about-us')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/contact">{t('navbar.contact-us')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/terms-of-service">{t('navbar.terms-conditions')}</Link>
                                                        </CenterMenuItem>
                                                        <CenterMenuItem onClick={handleClose}>
                                                            <Link component={RouterLink} to="/privacy-policy">{t('navbar.privacy-policy')}</Link>
                                                        </CenterMenuItem>
                                                    </MenuList>
                                                    : null}
                                            </li>
                                            <li className='hamburger-menu-content_item' onClick={() => setModalSearchOpen(true)} ><SearchOutlined className='navbar-icon'  /></li>
                                            <li className='hamburger-menu-content_item' onClick={() => setModalGetTrialOpen(true)}><PrimaryButton>{t('button.get-a-free-trial')}</PrimaryButton></li>
                                        </ul>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    }
                </div>

            </nav>
            {modalSearchOpen && <SearchInfoModal
                setModalSearchOpen={setModalSearchOpen}
                handleOverlayClick={handleOverlayClick}
                modalSearchRef={modalSearchRef} />}
            {modalGetTrialOpen && <ModalContactGetTrialForm
                setOpenModal={setModalGetTrialOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalGetTrialRef} />}
        </>




    )
}

export default Navbar